export class CreateCloudAccountRequest {
    customerId?: string;
    description?: string;
    region?: string;
}